export default Object.freeze({
    PHYSICIAN: 'physician',
    ANCILLARY: 'ancillary',
    OTHER: 'other',
})
